import { HttpError } from '@/shared/api/httpClient';
import { ehErroProdutoBloqueado } from '@/features/complementos/api/complementosApi';

const formatadorMoeda = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
});

const formatadorDataHora = new Intl.DateTimeFormat('pt-BR', {
  day: '2-digit',
  month: '2-digit',
  year: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
});

/**
 * Valores do PDV não passam pelo "ocultar valores" do resto do app: no
 * balcão o operador precisa ler o total para cobrar, e um `R$ ●●●●`
 * ali seria só um obstáculo.
 */
export function formatarDinheiro(valor: number): string {
  return formatadorMoeda.format(valor || 0);
}

export function formatarDataHora(iso: string | null): string {
  if (!iso) return '—';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '—' : formatadorDataHora.format(d);
}

export function textoDoErro(err: unknown): string {
  // A tela do PDV já está sendo trocada pelo bloqueio (ver `AcessoPdv`);
  // enquanto isso, nada de mensagem técnica do backend.
  if (ehErroProdutoBloqueado(err, 'pdv')) {
    return err instanceof HttpError && err.payload?.codigo === 'pdv.sem_conexao'
      ? 'Conecte à internet para confirmar o PDV.'
      : 'O PDV não está liberado nesta conta. Verificando a assinatura…';
  }
  if (err instanceof Error && err.message) return err.message;
  return 'Não foi possível concluir. Tente de novo.';
}
